import { RESET_FORM } from '../actionTypes';
import { createTemplateModalActions } from '../reducer';

export default () => createTemplateModalActions[RESET_FORM]();
